import React from 'react';
import UseCasePageTemplate from '../../../components/UseCasePageTemplate';
import DataQualityAnimation from '../../../components/DataQualityAnimation';

const DataQualityPage = () => {
  // Shield icon for data quality
  const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
    </svg>
  );

  // Icons for solutions
  const monitorIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
  );

  const testIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
    </svg>
  );

  const alertIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
    </svg>
  );

  // Icons for benefits
  const timeIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );

  const trustIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
    </svg>
  );

  const costIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );

  // Icon for related use cases
  const dashboardIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
  );

  const meshIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );

  const challenges = [
    {
      title: "Diverse and Disconnected Data Sources",
      description: "Managing data quality across multiple disconnected platforms, warehouses, and tools creates monitoring blind spots and makes it difficult to establish a single source of truth."
    },
    {
      title: "Reactive vs. Proactive Quality Management",
      description: "Most organizations discover data quality issues only after they've impacted downstream processes or resulted in business decisions based on flawed data."
    },
    {
      title: "Manual, Code-Heavy Testing Approaches",
      description: "Traditional data quality monitoring requires custom code for each test, making it time-consuming to implement and maintain comprehensive quality monitoring."
    },
    {
      title: "Siloed Knowledge and Limited Visibility",
      description: "Data quality knowledge is often trapped within teams, creating opacity about which quality checks exist, which data is validated, and who is responsible for which assets."
    }
  ];

  const solutions = [
    {
      icon: monitorIcon,
      title: "Comprehensive Quality Monitoring",
      description: "Deploy data quality monitoring across your entire data ecosystem with a unified platform that provides visibility into freshness, volume, schema, lineage, and distribution metrics.",
      items: [
        "Automated health checks for all your data assets",
        "Customizable freshness and volume monitoring",
        "Schema change detection and validation",
        "Advanced distribution and statistical anomaly detection",
        "Field-level quality assessment and tracking"
      ]
    },
    {
      icon: testIcon,
      title: "Flexible Testing Framework",
      description: "Create, manage, and scale data quality testing with out-of-the-box templates and customizable tests that adapt to your specific business rules.",
      items: [
        "Pre-built test templates for common quality checks",
        "No-code/low-code test creation interface",
        "SQL-based custom tests for advanced needs",
        "Test version control and management",
        "Automated test suggestions based on data profiling"
      ]
    },
    {
      icon: alertIcon,
      title: "Intelligent Alerting and Incident Management",
      description: "Reduce alert fatigue and accelerate incident resolution with smart notifications, collaborative workflows, and root cause analysis tools.",
      items: [
        "Configurable alert thresholds and severity levels",
        "Alert routing to appropriate owners and teams",
        "Integration with Slack, Teams, and other communication tools",
        "Incident tracking and resolution management",
        "Historical incident analytics and trend reporting"
      ]
    }
  ];

  const benefits = [
    {
      icon: timeIcon,
      title: "50% Reduction in MTTR",
      description: "Dramatically reduce mean time to resolution for data quality issues with early detection and automated root cause analysis."
    },
    {
      icon: trustIcon,
      title: "Improved Stakeholder Trust",
      description: "Build confidence with business users by delivering reliable, consistent data they can trust for critical business decisions."
    },
    {
      icon: costIcon,
      title: "Lower Operational Costs",
      description: "Reduce the cost of bad data by preventing quality issues from impacting downstream processes and business operations."
    }
  ];

  const relatedUsesCases = [
    {
      icon: dashboardIcon,
      title: "Report and dashboard integrity",
      description: "Produce reliable data your company can trust.",
      href: "/use-cases/data-observability"
    },
    {
      icon: meshIcon,
      title: "Data mesh and self serve data",
      description: "Empower data producers and consumers to self-serve.",
      href: "/use-cases/dataops-automation"
    }
  ];

  return (
    <UseCasePageTemplate
      title="Data Quality Monitoring and Testing"
      description="Deploy and manage comprehensive data quality monitors and tests on one unified platform to ensure reliable data across your entire ecosystem."
      heroAnimation={<DataQualityAnimation />}
      icon={icon}
      challenges={challenges}
      solutions={solutions}
      benefits={benefits}
      relatedUsesCases={relatedUsesCases}
      additionalContent={
        <div className="bg-gray-50 p-8 rounded-lg">
          <h3 className="text-2xl font-bold mb-4">Comprehensive Data Quality Strategy</h3>
          <p className="mb-4">
            Qupid's data quality monitoring and testing platform empowers your team to implement a holistic approach to data quality management that scales with your organization.
          </p>
          <p>
            By combining automated monitoring with flexible testing capabilities, you can ensure that quality issues are detected early, resolved quickly, and prevented in the future through continuous improvement of your data pipelines and processes.
          </p>
        </div>
      }
    />
  );
};

export default DataQualityPage; 